import {
  FETCH_DEMARCATE_JUSTIFY_FILTER_REQUEST,
  FETCH_DEMARCATE_JUSTIFY_FILTER_SUCCESS,
  FETCH_DEMARCATE_JUSTIFY_FILTER_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  error: null,
  isFetching: false,
  list: [],
}

const demarcateJustifies = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_DEMARCATE_JUSTIFY_FILTER_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case FETCH_DEMARCATE_JUSTIFY_FILTER_SUCCESS:
      return {
        ...state,
        error: null,
        list: action.payload,
        isFetching: false,
      }

    case FETCH_DEMARCATE_JUSTIFY_FILTER_ERROR:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      }

    default:
      return state
  }
}
export default demarcateJustifies
